import { Products, mergeProducts } from './products'

export interface PreISUProductsResponse {
  sections: any[]
  products: Products
  vendors: any
}

export const mergePreISUProductsResponses = (
  a: PreISUProductsResponse,
  b: PreISUProductsResponse,
): PreISUProductsResponse => {
  const response: PreISUProductsResponse = {
    ...a,
    products: mergeProducts(a.products, b.products),
  }
  return response
}
